import React, { useState } from 'react';
import './MedicalHistoryForm.css';

const MedicalHistoryForm = ({ onBack }) => {
  const [inpatient, setInpatient] = useState('');
  const [ambulance, setAmbulance] = useState('');
  const [treatment, setTreatment] = useState('');
  const [funding, setFunding] = useState('');

  return (
    <div className="mhf-container">
      <div className="mhf-header">
        <button className="mhf-back" onClick={onBack} aria-label="Kembali">←</button>
        <span className="mhf-title">Bantuan Medis & Kesehatan</span>
      </div>
      <div className="mhf-stepper">
        <span className="mhf-step done">1</span>
        <span className="mhf-step-label done">Detail pasien</span>
        <span className="mhf-step-line done"></span>
        <span className="mhf-step active">3</span>
        <span className="mhf-step-label active">Riwayat medis</span>
        <span className="mhf-step-line"></span>
        <span className="mhf-step">4</span>
        <span className="mhf-step-label">Target donasi</span>
      </div>
      <form className="mhf-form">
        <div className="mhf-group">
          <label className="mhf-label">Apakah pasien sedang menjalani rawat inap di rumah sakit?</label>
          <div className="mhf-radio-group">
            <label className={`mhf-radio ${inpatient==='ya' ? 'checked' : ''}`}>
              <input type="radio" name="inpatient" checked={inpatient==='ya'} onChange={() => setInpatient('ya')} />
              Ya, sedang rawat inap
            </label>
            <label className={`mhf-radio ${inpatient==='tidak' ? 'checked' : ''}`}>
              <input type="radio" name="inpatient" checked={inpatient==='tidak'} onChange={() => setInpatient('tidak')} />
              Tidak
            </label>
          </div>
        </div>
        <div className="mhf-group">
          <span className="mhf-ambulance-icon">🚑</span>
          <label className="mhf-label">Butuh penjemputan ambulance?</label>
          <div className="mhf-radio-group">
            <label className={`mhf-radio ${ambulance==='ya' ? 'checked' : ''}`}>
              <input type="radio" name="ambulance" checked={ambulance==='ya'} onChange={() => setAmbulance('ya')} />
              Ya, butuh
            </label>
            <label className={`mhf-radio ${ambulance==='tidak' ? 'checked' : ''}`}>
              <input type="radio" name="ambulance" checked={ambulance==='tidak'} onChange={() => setAmbulance('tidak')} />
              Tidak
            </label>
          </div>
        </div>
        <div className="mhf-group">
          <label className="mhf-label">Upaya pengobatan yang sudah atau sedang dilakukan</label>
          <textarea
            className="mhf-textarea"
            placeholder="Jelaskan secara lengkap upaya apa yang dilakukan dan tempat dilakukannya.\n(Cth. Operasi shunt jantung di RS Pusat Jantung, terapi wicara di RSCM, dsb.)"
            value={treatment}
            onChange={e => setTreatment(e.target.value)}
          />
        </div>
        <div className="mhf-group">
          <label className="mhf-label">Dari mana sumber biaya pengobatan/ perawatan yang telah dilakukan sebelumnya?</label>
          <div className="mhf-radio-group">
            <label className={`mhf-radio ${funding==='mandiri' ? 'checked' : ''}`}>
              <input type="radio" name="funding" checked={funding==='mandiri'} onChange={() => setFunding('mandiri')} />
              Biaya mandiri
            </label>
            <label className={`mhf-radio ${funding==='asuransi' ? 'checked' : ''}`}>
              <input type="radio" name="funding" checked={funding==='asuransi'} onChange={() => setFunding('asuransi')} />
              Asuransi (BPJS dan/atau swasta)
            </label>
          </div>
        </div>
        <div className="mhf-actions">
          <button type="button" className="mhf-btn secondary" onClick={onBack}>Sebelumnya</button>
          <button type="submit" className="mhf-btn primary">Selanjutnya</button>
        </div>
        <button type="button" className="mhf-btn link">Simpan dan lanjutkan nanti</button>
      </form>
    </div>
  );
};

export default MedicalHistoryForm;
